import React from 'react';
import { connect } from 'react-redux';
import { defineMessages, injectIntl, intlShape } from 'react-intl';
import core from '@bravissimolabs/website-core';
import ShopsSectionPage from 'brastrap/editorial/shops-section-page/ShopsSectionPage';
import Meta from 'shared/containers/MetaContainer';
import { receiveAllShops, updateAccordion } from 'shared/actions/shops';

const messages = defineMessages({
  title: {
    id: 'shops-page.title',
    defaultMessage: 'Find a Shop',
  },
  description: {
    id: 'shops-page.description',
    defaultMessage:
      "Find your closest Bravissimo shop using this map. We'd love to see you in store." +
      'Our fitters are friendly, knowledgeable and want to help you feel your best',
  },
});

const ShopsPage = props => (
  <Meta
    title={props.intl.formatMessage(messages.title)}
    description={props.intl.formatMessage(messages.description)}
  >
    <ShopsSectionPage {...props} />
  </Meta>
);

/**
 * Populate list of shops
 *
 * @param {object} store
 */
ShopsPage.populateStore = async store => {
  const api = core.shop.shop;

  const shops = await api.getShops();

  store.dispatch(receiveAllShops(shops));
};

ShopsPage.propTypes = {
  intl: intlShape,
};

const mapStateToProps = state => ({
  ...state.map,
  selectedLocale: state.app.locale.selected,
  accordion: state.shops.accordion,
  shops: state.shops.all,
});

const mapDispatchToProps = dispatch => ({
  updateAccordion: country => dispatch(updateAccordion(country)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(ShopsPage));
